import script from "./Metas.vue?vue&type=script&setup=true&lang=js"
export * from "./Metas.vue?vue&type=script&setup=true&lang=js"

import "./Metas.vue?vue&type=style&index=0&id=330221b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-330221b4"]])

export default __exports__